import { AllJobsPage } from './all-jobs/all-jobs'

export const JobsStack = {
  AllJobsPage,
}
